import { types } from "../types/types";

const initialState = {
  
  visions: [],
  
  vision: {},
  visionSaved: {},
  visionSelected: {},

  visionsP: [],
  totalItemsVisionP: 0,
  totalPagesVisionP: 0,
  currentPageVisionP: 0,

  visionsS: [],
  totalItemsVisionS: 0,
  totalPagesVisionS: 0,
  currentPageVisionS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberVisionSelected: 0,

   isLoadingVisions: false
};

/*
const countNumberIsSelected = (visions) => {
  let countCompare = 0;
  visions.forEach(element => {
    if(element.isSelected){
      countCompare ++;
    }
  });
  return countCompare;
}*/

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const visionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VISION_START_REGISTER_ADMIN:

      //console.log("vision in register", action.payload);
      return {
        ...state,
        visionSaved: action.payload,
      };

    case types.VISION_UPDATE:
      if (state.visionsS.length > 0) {
        return {
          ...state,
          visionsS: state.visionsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          visionsP: state.visionsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          visionsP: state.visionsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.VISION_DELETE:
      if (state.visionsS.length > 0) {
        return {
          ...state,
          visionsS: state.visionsS.filter((usr) => usr.id !== action.payload),
          visionsP: state.visionsP.filter((usr) => usr.id !== action.payload),
          visionSelected: {},
        };
      } else {
        return {
          ...state,
          visionsP: state.visionsP.filter((usr) => usr.id !== action.payload),
          visionSelected: {},
        };
      }

    case types.VISION_START_LOADING_PAGINATED:
      return {
        ...state,
        visionsP: action.payload.visionsP,
        totalItemsVisionP: action.payload.totalItems,
        totalPagesVisionP: action.payload.totalPages,
        currentPageVisionP: action.payload.currentPage,
      };

    case types.VISION_START_LOADING_VISION_PAGINATED:
      
      return {
        ...state,
        visionsS: action.payload.visionsP,
        totalItemsVisionS: action.payload.totalItems,
        totalPagesVisionS: action.payload.totalPages,
        currentPageVisionS: action.payload.currentPage,
      };

    case types.VISION_START_SEARCH_PAGINATED:
      return {
        ...state,
        visionsS: action.payload.visionsP,
        totalItemsVisionS: action.payload.totalItems,
        totalPagesVisionS: action.payload.totalPages,
        currentPageVisionS: action.payload.currentPage,
      };

    case types.VISION_SELECT:
      return {
        ...state,
        visionSelected: action.payload,
      };

    case types.VISION_CLEAN_SEARCH_PAGINATED:
      //console.log("9999, Llego al reducer VISION_CLEAN_SEARCH_PAGINATED");
      return {
        ...state,
        visionsS: [],
        totalItemsVisionS: 0,
        totalPagesVisionS: 0,
        currentPageVisionS: 0,
      };

    case types.VISION_CLEAN_PAGINATED:
      return {
        ...state,
        visionsP: [],
        totalItemsVisionP: 0,
        totalPagesVisionP: 0,
        currentPageVisionP: 0,

      };

    case types.VISION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.VISION_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.VISION_CLEAN_SAVED:
      return {
        ...state,
        visionSaved: {},
      };

      /*
    case types.VISION_LIST_UPDATE_SELECTED:
      
      if (state.visionsS.length > 0) {
        return {
          ...state,
          visionsS: state.visionsS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

        };
      }
      break;
      */
     case types.VISION_LIST_UPDATE_SELECTED: {
           const id = action.payload;
           const currentSelectedCount = countSelected(state.visionsS);
           const targetItem = state.visionsS.find(item => item.id === id);
     
           // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
           if (!targetItem.isSelected && currentSelectedCount >= 9) return state;
     
           const newVisions = state.visionsS.map(item =>
             item.id === id ? { ...item, isSelected: !item.isSelected } : item
           );
     
           const newCount = countSelected(newVisions);
     
           return {
             ...state,
             visionsS: newVisions,
             numberVisionSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Selección masiva (Primeros 9 o todos si hay menos)
         case types.VISION_SELECT_ALL_LIMIT: {
           const newVisions = state.visionsS.map((item, index) => ({
             ...item,
             isSelected: index < 9 // Selecciona solo los primeros 9
           }));
     
           const newCount = countSelected(newVisions);
     
           return {
             ...state,
             visionsS: newVisions,
             numberVisionSelected: newCount,
             moreThanOneIsSelected: newCount > 1
           };
         }
     
         // Limpiar todo
         case types.VISION_CLEAN_ALL_SELECTED: {
           return {
             ...state,
             visionsS: state.visionsS.map(item => ({ ...item, isSelected: false })),
             numberVisionSelected: 0,
             moreThanOneIsSelected: false
           };
         }

    case types.VISION_GET_MORE_THAN_ONE_SELECTED:
      //console.log("reducer, GET_MORE_THAN_ONE_SELECTED")
      if (state.visionsS.length > 0) {
        //console.log("state.visionsS.length", state.visionsS.length)
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.VISION_LIST_SET_NUMBER_SELECTED:
      //console.log("VISION_LIST_SET_NUMBER_SELECTED, action.payload", action.payload)
      if (state.visionsS.length > 0) {
        return {
          ...state,
          numberVisionSelected: action.payload
        };
      }
      break;

    case types.VISION_CLEAN_SEARCH_INFORMATION:
      return {
        ...state,
        numberVisionSelected: 0
      };

             case types.VISION_IS_LOADING:

        return {
          ...state,
          isLoadingVisions: true
        };
    
      case types.VISION_IS_LOADING_FINISH:

        return {
          ...state,
          isLoadingVisions: false
        };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {
  //console.log("state.getMoreThanOneIsSelected", state.getMoreThanOneIsSelected);

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.visionsS.length > 0) {
    state.visionsS.forEach(element => {

      if (element.isSelected) {
        //console.log("element.isSelected", element.isSelected)
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
      //console.log("la cuenta esta en, counterFlagMoreThanOneIsSelected", counterFlagMoreThanOneIsSelected);
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    //console.log("counterFlagMoreThanOneIsSelected", counterFlagMoreThanOneIsSelected)
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}